import {compose as C, map as m, nth,pick, __, divide, tap, defaultTo, values, uniq, append, mean, multiply, apply, toLower} from "ramda";
import {r} from "./math"
import { useSelector } from "react-redux";
import { stdev, the_mean } from "./mean";

export const share = item_nr => (selected,country,data) => C(
    m(C(divide(__,100),r(0))),
    pick(selected.concat([country])),
    defaultTo({}),
    nth(item_nr),
)(data) 

export const explain_share = ({data,unit,diff,country,comparison,scale,item}) => {
    const selected_data = C(pick(__,data),uniq,append(country))(comparison);
    const value = r(1,selected_data[country]*100);
    const avg = the_mean(selected_data);
    const std = stdev(avg,selected_data);
    const min_val = C(r(1),multiply(100))(Math.min(...values(selected_data)));
    const max_val = C(r(1),multiply(100))(Math.max(...values(selected_data)));
    const word = scale[Math.floor(diff/0.2)];

    return `In selected country ${value} % are ${toLower(item||"")} and in comparison group on average ${r(1,avg*100)} % are ${toLower(item||"")}. In current selection the lowest is ${min_val} %, and the highest is ${max_val} %. Standard deviation is ${r(1,std*100)} percentage points. The relative difference measured in standard deviations assuming normal distribution of differences is therefore ${r(1,diff*100)} % which can be interpreted as${diff <= 0.2 ? " among" : ""} ${word} (${Math.floor(diff/0.2)+1}/5) ${diff <= 0.2 ? "" : "from comparison group average"}.`
}